const React = require('react');
const withState = require('../../../../utils/withState');
const {default: IconButton} = require("@material-ui/core/IconButton");
const {default: VisibilityOff} = require("@material-ui/icons/VisibilityOff");
const {default: Visibility} = require("@material-ui/icons/Visibility");

const Component = withState((setState) => {
  return ({showPassword}, {Input, ...props}) => {
    const VisibilityIcon = showPassword
      ? VisibilityOff
      : Visibility;

    return (
      <Input
        {...props}
        className={'(f8).dotsDisplay>.MuiInputBase-input' + (!showPassword ? ' dotsDisplay' : '')}
        type={showPassword ? 'text' : 'password'}
        endAdornment={(
          <IconButton
            className="rlv mv-5*2"
            onClick={() => {
              setState({
                showPassword: !showPassword,
              });
            }}
          >
            <VisibilityIcon
              className="c0C"
            />
          </IconButton>
        )}
      />
    )
  }
})

module.exports = (Input) => (props) => (
  <Component
    {...props}
    Input={Input}
  />
)
